import { createContext } from 'react';

export const OverlayIdContext = createContext<number>(0);
